export enum IssueStatusEnum {
  DRAFT = 'issue-draft',
  // Remove in RCP-38872 once all consumers send 'issue-in-review'.
  /** @deprecated Use IN_REVIEW instead. Will be removed. */
  OPEN = 'issue-open',
  IN_REVIEW = 'issue-in-review',
  TO_BE_PUBLISHED = 'issue-to-be-published',
  PENDING_ACCEPTANCE = 'issue-pending-acceptance',
  IN_PROGRESS = 'issue-in-progress',
  REMEDIATION_PLANNING = 'issue-remediation-planning',
  IN_REMEDIATION = 'issue-in-remediation',
  TO_BE_APPROVED = 'issue-to-be-approved',
  CLOSED = 'issue-closed',
  DISCARDED = 'issue-discarded',
}

export type IssueStatusType =
  | IssueStatusEnum.DRAFT
  | IssueStatusEnum.OPEN
  | IssueStatusEnum.IN_REVIEW
  | IssueStatusEnum.TO_BE_PUBLISHED
  | IssueStatusEnum.PENDING_ACCEPTANCE
  | IssueStatusEnum.IN_PROGRESS
  | IssueStatusEnum.REMEDIATION_PLANNING
  | IssueStatusEnum.IN_REMEDIATION
  | IssueStatusEnum.TO_BE_APPROVED
  | IssueStatusEnum.CLOSED
  | IssueStatusEnum.DISCARDED;

// Maps deprecated 'issue-open' to IN_REVIEW. Apply at API input boundaries.
// Remove in RCP-38872 once all consumers send 'issue-in-review'.
export function normalizeIssueStatus(
  status: IssueStatusEnum | string,
): IssueStatusEnum {
  if (status === IssueStatusEnum.OPEN) {
    return IssueStatusEnum.IN_REVIEW;
  }
  return status as IssueStatusEnum;
}

export const IssueStatusNotActionable = [
  IssueStatusEnum.CLOSED,
  IssueStatusEnum.DISCARDED,
];

export const IssueStatusActionable = [
  IssueStatusEnum.DRAFT,
  IssueStatusEnum.IN_REVIEW,
  IssueStatusEnum.TO_BE_PUBLISHED,
  IssueStatusEnum.PENDING_ACCEPTANCE,
  IssueStatusEnum.IN_PROGRESS,
  IssueStatusEnum.TO_BE_APPROVED,
];

export const IssueStatusLateActionable = [
  IssueStatusEnum.TO_BE_PUBLISHED,
  IssueStatusEnum.PENDING_ACCEPTANCE,
  IssueStatusEnum.IN_PROGRESS,
  IssueStatusEnum.TO_BE_APPROVED,
];
